import React, { useState } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import Topic from './topic';
import SubTopics from '../SubTopics';

/** Admin > Topics: the main topics and their sub topics, in two inner tabs. */
const TopicManager: React.FC = () => {
  const [tab, setTab] = useState<'topics' | 'subtopics'>('topics');
  // topic whose sub topics were opened with "View Sub Topics" in a topic row; null shows the sub topics of all topics
  const [viewParent, setViewParent] = useState<number | null>(null);

  const showTab = (next: 'topics' | 'subtopics') => {
    setViewParent(null);
    setTab(next);
  };

  return (
    <div className="card topic-tab topic-manager">
      <Nav pills className="topic-inner-tabs">
        <NavItem>
          <NavLink className={classnames({ active: tab === 'topics' })} onClick={() => showTab('topics')}>
            Topics
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink className={classnames({ active: tab === 'subtopics' })} onClick={() => showTab('subtopics')}>
            Sub Topics
          </NavLink>
        </NavItem>
      </Nav>
      {tab === 'topics' ? (
        <Topic
          onViewSubTopics={parentId => {
            setViewParent(parentId);
            setTab('subtopics');
          }}
        />
      ) : (
        <SubTopics initialParentId={viewParent} onBackToTopics={() => showTab('topics')} />
      )}
    </div>
  );
};

export default TopicManager;
